var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#A5A5A8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 12.6667C2.66683 13.6667 2.66683 11 1.3335 10.6667M10.6668 14.6667V12.0867C10.6918 11.7688 10.6489 11.4492 10.5408 11.1492C10.4328 10.8492 10.2621 10.5756 10.0402 10.3467C12.1335 10.1133 14.3335 9.32 14.3335 5.68C14.3333 4.74922 13.9753 3.85413 13.3335 3.18C13.6374 2.36567 13.6159 1.46557 13.2735 0.666666C13.2735 0.666666 12.4868 0.433332 10.6668 1.65333C9.13884 1.23921 7.52816 1.23921 6.00016 1.65333C4.18016 0.433332 3.3935 0.666666 3.3935 0.666666C3.05108 1.46557 3.02959 2.36567 3.3335 3.18C2.68691 3.85913 2.32851 4.76231 2.3335 5.7C2.3335 9.31333 4.5335 10.1067 6.62683 10.3667C6.40749 10.5933 6.23834 10.8636 6.13037 11.1599C6.0224 11.4563 5.97803 11.772 6.00016 12.0867V14.6667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.5d70ce34b477b95cf98f93d4d2dd99a6.svg";
export { ForwardRef as ReactComponent };